import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  type SeriesPoint,
  type SummaryGroup,
} from "../../../domain/entities/referral-backoffice";
import { type SummaryParams } from "../../../domain/repos/referrals-backoffice-repo";
import { type ReferralsBackofficeDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

/**
 * One supervisor's ambassadors, for the admin table's inline expansion. It
 * carries its own daily series because the parent read grouped by supervisor,
 * so its series is keyed by supervisor and cannot feed an ambassador's
 * sparkline.
 */
export const getSupervisorAmbassadors = createAsyncThunk<
  { supervisorId: string; groups: SummaryGroup[]; series: SeriesPoint[] },
  Omit<SummaryParams, "groupBy" | "series" | "seriesPeriods"> & {
    supervisorId: string;
  },
  { dispatch: ReferralsBackofficeDispatch; extra: ExtraArgument; state: State }
>(
  thunkTypes.GET_SUPERVISOR_AMBASSADORS,
  async ({ supervisorId, ...params }, { extra }) => {
    const summary = await extra.referralsBackofficeRepo.summary({
      ...params,
      supervisorId,
      groupBy: "ambassador",
      series: "day",
    });
    return {
      supervisorId,
      groups: summary.groups,
      series: summary.series ?? [],
    };
  },
);
